// test2347
(2347 && 0);
